


import React, { useState } from "react";
import html2pdf from "html2pdf.js";
import { FaFilePdf } from "react-icons/fa";

const ReportDownload = ({ users, title, pageSize = 20 }) => {
  const [isGenerating, setIsGenerating] = useState(false);

  const chunkArray = (arr, size) => {
    return Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );
  };

  const handleDownload = async () => {
    if (users.length === 0) return;
    setIsGenerating(true);

    const element = document.getElementById("report-print-container");
    const options = {
      margin: [10, 10, 10, 10],
      filename: `${title.replace(/\s+/g, '_')}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" }, // Portrait works better for this vertical list
      pagebreak: { mode: ['css', 'legacy'] }
    };

    try {
      await html2pdf().set(options).from(element).save();
    } catch (error) {
      console.error("Report generation failed", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const userChunks = chunkArray(users, pageSize);
  const generatedAt = new Date().toLocaleString();

  return (
    <>
      <button
        className="btn btn-outline-danger w-100 btn-sm fw-bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2 mt-2"
        onClick={handleDownload}
        disabled={isGenerating || users.length === 0}
      >
        {isGenerating ? <span className="spinner-border spinner-border-sm" /> : <FaFilePdf />}
        {isGenerating ? "Generating Report..." : `Download PDF Report`}
      </button>

      {/* HIDDEN PRINT AREA */}
      <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
        <div id="report-print-container" style={{ width: "190mm", backgroundColor: "#fff", fontFamily: "Arial, sans-serif" }}>
          
          {userChunks.map((chunk, pageIndex) => (
            <div key={pageIndex} style={{ pageBreakAfter: "always", paddingBottom: "10mm" }}>
              
              {/* HEADER WITH LOGOS */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid #088d01", paddingBottom: "5px", marginBottom: "15px" }}>
                <img src="/coat-of-arms.png" alt="Coat of Arms" style={{ width: "40px", height: "auto" }} />
                <div style={{ textAlign: "center" }}>
                  <h4 style={{ margin: 0, color: "#088d01", fontWeight: "bold", textTransform: "uppercase" }}>Labour Party Nigeria</h4>
                  <h6 style={{ margin: 0, color: "#333" }}>{title}</h6>
                  <p style={{ fontSize: "9px", margin: 0, color: "#777" }}>Generated At: {generatedAt}</p>
                </div>
                <img src="/logo2.jpeg" alt="Labour Party" style={{ width: "120px", height: "auto" }} />
              </div>

              {/* USER RECORDS LIST */}
              {chunk.map((user, i) => (
                <div key={i} style={{ 
                  display: "flex", 
                  borderBottom: "1px solid #eee", 
                  padding: "8px 0", 
                  pageBreakInside: "avoid",
                  alignItems: "center"
                }}>
                  {/* LEFT COLUMN: BIG IMAGE */}
                  <div style={{ width: "45mm", paddingRight: "10px" }}>
                    <img 
                      src={user.passportUrl || "/default-avatar.png"} 
                      alt="User" 
                      style={{ width: "100%", height: "45mm", objectFit: "cover", borderRadius: "4px", border: "1px solid #ddd" }}
                      crossOrigin="anonymous"
                    />
                  </div>

                  {/* RIGHT COLUMN: INFORMATION */}
                  <div style={{ flex: 1, display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4px", fontSize: "10px" }}>
                    <div style={{ gridColumn: "span 2", borderBottom: "1px solid #f0f0f0", marginBottom: "4px" }}>
                        <strong style={{ fontSize: "18px", color: "#088d01" }}>{`${user.firstName} ${user.middleName || ''} ${user.lastName}`}</strong>
                        <span style={{fontSize: "18px",float: "right", color: "#888" }}>ID: LP/{user.regID}</span>
                    </div>
                    <div><strong>Gender:</strong> {user.gender}</div>
                    <div><strong>DOB:</strong> {user.dob ? new Date(user.dob).toLocaleDateString() : "N/A"}</div>
                     <div><strong>SEX:</strong> {user.gender || "N/A"}</div>
                    <div><strong>NIN:</strong> {user.nationalId || "N/A"}</div>
                    <div><strong>Phone:</strong> {user.phoneNumber}</div>
                    <div><strong>State:</strong> {user.state}</div>
                      <div><strong>LGA:</strong> {user.lga}</div>
                    <div><strong>Ward:</strong> {user.ward}</div>
                    <div><strong>PU:</strong> {user.pollingUnit}</div>
                    <div style={{ gridColumn: "span 2" }}><strong>Address:</strong> {user.residentialAddress}</div>
                  </div>
                </div>
              ))}

              <div style={{ textAlign: "center", marginTop: "10px", fontSize: "10px", color: "#999" }}>
                Page {pageIndex + 1} of {userChunks.length}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ReportDownload;